import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_API_URL || process.env.REACT_APP_BACKEND_URL || "";
export const API = BACKEND_URL
  ? (BACKEND_URL.endsWith("/api") ? BACKEND_URL : `${BACKEND_URL}/api`)
  : "/api";

const client = axios.create({ baseURL: API, withCredentials: true });

client.interceptors.request.use((config) => {
  try {
    if (!config.headers["Authorization"]) {
      const raw = localStorage.getItem("petualangan_bayi_state_v1");
      if (raw) {
        const parsed = JSON.parse(raw);
        if (parsed && parsed.parentToken) {
          config.headers["Authorization"] = `Bearer ${parsed.parentToken}`;
        }
      }
    }
  } catch (err) {
    console.warn("Failed to retrieve parent token for request:", err);
  }
  return config;
}, (error) => {
  return Promise.reject(error);
});

export const api = {
  loginParent: (data) => client.post("/parents/login", data).then((r) => r.data),
  logoutParent: () => client.post("/parents/logout").then((r) => r.data),
  createParent: (data) => client.post("/parents", data).then((r) => r.data),
  getParent: (id) => client.get(`/parents/${id}`).then((r) => r.data),
  getParentAccess: (parent_id) => client.get(`/parents/${parent_id}/access`).then((r) => r.data),
  updateParent: (id, data) => client.patch(`/parents/${id}`, data).then((r) => r.data),
  forgotPassword: (data) => client.post("/parents/forgot-password", data).then((r) => r.data),
  resetPassword: (data) => client.post("/parents/reset-password", data).then((r) => r.data),
  changePassword: (id, data) => client.post(`/parents/${id}/change-password`, data).then((r) => r.data),
  createChild: (data) => client.post("/children", data).then((r) => r.data),
  listChildren: (parent_id) =>
    client.get("/children", { params: { parent_id } }).then((r) => r.data),
  deleteChild: (id) => client.delete(`/children/${id}`).then((r) => r.data),
  recordProgress: (data) => client.post("/progress", data).then((r) => r.data),
  getProgress: (child_id) => client.get(`/progress/${child_id}`).then((r) => r.data),
  getProgressSummary: (child_id) =>
    client.get(`/progress/${child_id}/summary`).then((r) => r.data),
  getResearchSummary: (child_id) =>
    client.get(`/research/summary/${child_id}`).then((r) => r.data),
  listResearchEvents: (child_id, limit = 100) =>
    client.get(`/research/events/${child_id}`, { params: { limit } }).then((r) => r.data),
  resetResearchEvents: (child_id) =>
    client.delete(`/research/events/${child_id}`).then((r) => r.data),
  researchCsvUrl: (child_id) => `${API}/research/export/${child_id}`,

  googleLogin: (data) => client.post("/parents/google-login", data).then((r) => r.data),

  // Payments & Premium Access
  chargePayment: (data) => client.post("/payments/charge", data).then((r) => r.data),
  checkoutSimulated: (data) => client.post("/payments/checkout-simulated", data).then((r) => r.data),

  // Ads & Monetization
  getActiveAds: (placement) =>
    client.get("/ads/active", { params: { placement } }).then((r) => r.data),
  trackAdEvent: (data) =>
    client.post("/ads/track", data).then((r) => r.data),
  checkoutAdCampaign: (data) =>
    client.post("/ads/checkout", data).then((r) => r.data),
  getParentAds: (parent_id) =>
    client.get(`/parents/${parent_id}/ads`).then((r) => r.data),
};

